var React = require('react');
var createReactClass = require('create-react-class');
var PureRenderMixin = require('react-addons-pure-render-mixin');
var DashboardMyGi = require('../containers/dashboardMyGi.jsx');
var DashboardMyQol = require('../containers/dashboardMyQol.jsx');
var DashboardMyGiHistory = require('../containers/dashboardMyGiHistory.jsx');

var _dashboardType2Component = {
    'mygi': DashboardMyGi,
    'myqol': DashboardMyQol,
    'doctor-visit': DashboardMyGiHistory
};

var DashboardContainer = createReactClass({
    mixins: [PureRenderMixin],

    render: function(){
        var Dashboard = _dashboardType2Component[this.props.params.dashboardType ? this.props.params.dashboardType.toLowerCase() : 'mygi']
        return <Dashboard {...this.props} />;
    }
});

module.exports = DashboardContainer;


// WEBPACK FOOTER //
// ./src/common/routes/dashboard/components/dashboardContainer.jsx